import BookingsAdapter from './base';

export default class Slot extends BookingsAdapter {
  modelNamePlural = 'slots';
}
